import React from 'react'
import { Modal } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { setModalCreateClient } from 'src/actions/utilities.actions'
import CreateClientIndex from 'src/content/Clients/Create/CreateClientIndex'
import { selectIdentificationTypes } from 'src/selectors/company.selector'
import { selectModalCreateClient } from 'src/selectors/utilities.selector'

/**
 * @component ModalCreateClient
 * @description Client creation modal
 */
const ModalCreateClient = () => {
  const dispatch = useDispatch()

  const identificationTypes = useSelector(selectIdentificationTypes)
  const modalCreateClient = useSelector(selectModalCreateClient)

  return (
    <Modal
      show={modalCreateClient.show}
      centered
      size={'xl'}
      onHide={() => dispatch(setModalCreateClient({ show: false }))}>
      <Modal.Header closeButton>
        <Modal.Title>Cliente nuevo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CreateClientIndex
          inModal
          onlyCloseModal={response => {
            const identifications = {}
            identificationTypes.forEach(
              identificationType =>
                (identifications[identificationType.id] = {
                  identificationTypeId: identificationType.id,
                  value: '',
                }),
            )
            response.identifications?.forEach(
              identification =>
                (identifications[identification.identificationTypeId] = identification),
            )

            dispatch(
              setModalCreateClient({
                show: false,
              }),
            )

            modalCreateClient.onCreateOption?.(response, identifications)
          }}
        />
      </Modal.Body>
    </Modal>
  )
}
export default ModalCreateClient
